import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setQrCode } from "../redux/slices/qrSlice";

const Language = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { code } = useParams();

  const [selectedLang, setSelectedLang] = useState("en");

  const languages = [
    { label: "English", value: "en" },
    { label: "Hindi - हिन्दी", value: "hi" },
    { label: "Punjabi - ਪੰਜਾਬੀ", value: "pa" },
    { label: "Marathi - मराठी", value: "mr" },
    { label: "Gujarati - ગુજરાતી", value: "gu" },
    { label: "Kannada - ಕನ್ನಡ", value: "kn" },
    { label: "Telugu - తెలుగు", value: "te" },
    { label: "Tamil - தமிழ்", value: "ta" },
  ];

  useEffect(() => {
    const savedLang = localStorage.getItem("appLanguage");
    if (savedLang) setSelectedLang(savedLang);
  }, []);

  useEffect(() => {
    if (code) {
      dispatch(setQrCode(code));
      localStorage.setItem("qrCode", code);
    }
  }, [code, dispatch]);

  const handleContinue = () => {
    localStorage.setItem("appLanguage", selectedLang);
    navigate("/login");
  };

  return (
    <div
      className="min-h-screen flex justify-center"
      style={{
        fontFamily: "'Poppins', sans-serif",
        backgroundColor: "#fff5f5",
        backgroundImage:
          "radial-gradient(circle, #ffd6d6 1px, transparent 1px)",
        backgroundSize: "22px 22px",
      }}
    >
      <div className="w-full max-w-md min-h-screen flex flex-col">

        {/* TOP BAR */}
        <div className="flex justify-between items-center px-6 pt-5 pb-2">
          <img
            src="/Dhanuka-agritech-limited-logo.png"
            alt="Gencrest"
            className="h-20 w-auto object-contain"
          />

        </div>

        <div className="px-4 pt-2 pb-8 flex flex-col gap-4 flex-1">

          {/* BANNER */}
          <div className="rounded-3xl overflow-hidden shadow-lg border border-red-100">
            <img
              src="/coke_logo.png"
              alt="banner"
              className="w-full object-cover"
              style={{ "height": "200px" }}
            />
          </div>

          {/* LANGUAGE CARD */}
          <div className="bg-white rounded-3xl shadow-lg mx-1 overflow-hidden border border-red-100">

            {/* TOP STRIP */}
            <div className="h-2 bg-gradient-to-r from-[#e60012] via-[#ff4040] to-[#b3000f]" />

            {/* CARD CONTENT */}
            <div className="px-5 py-6">

              <h1 className="text-[22px] font-bold text-[#b3000f] mb-1">
                Select Language
              </h1>

              <p className="text-[12px] text-gray-500 mb-5 leading-relaxed">
                Choose your preferred language to continue
              </p>

              {/* LANGUAGE GRID */}
              <div className="grid grid-cols-2 gap-3 mb-5">
                {languages.map((lang) => {
                  const isEnabled = lang.value === "en";

                  return (
                    <button
                      key={lang.value}
                      disabled={!isEnabled}
                      onClick={() => {
                        if (isEnabled) {
                          setSelectedLang(lang.value);
                        }
                      }}
                      className={`relative py-3 px-3 rounded-2xl text-[13px] font-semibold text-left transition-all border-[1.5px] shadow-sm
          
          ${selectedLang === lang.value && isEnabled
                          ? "border-[#e60012] bg-gradient-to-r from-[#e60012] to-[#b3000f] text-white"
                          : isEnabled
                            ? "border-red-100 bg-red-50/40 text-[#222]"
                            : "border-gray-200 bg-gray-100 text-gray-400 cursor-not-allowed opacity-70"
                        }
        `}
                    >
                      <div className="flex items-center justify-between">
                        <span>{lang.label}</span>


                      </div>
                    </button>
                  );
                })}
              </div>

              {/* CONTINUE BUTTON */}
              <button
                onClick={handleContinue}
                className="w-full py-3.5 rounded-2xl text-[15px] font-bold text-white flex items-center justify-center gap-2 active:scale-[0.98] transition-transform shadow-md"
                style={{
                  background:
                    "linear-gradient(135deg, #e60012 0%, #b3000f 100%)",
                }}
              >
                Continue

                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        {/* <div className="w-full py-3 border-t">
          <p className="text-[13px] text-red-600 uppercase text-center tracking-wide font-semibold">
            © {new Date().getFullYear()} Consumer Journeys. All Rights Reserved.
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default Language;